import React, { useEffect, useState } from "react";
import { humanFileSize } from "../../Utils/functions";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { toast } from "react-toastify";
const ImageUploader = ({
  element,
  form,
  setForm,
  edit = false,
  single = true,
}) => {
  const onSelectFile = e => {

    if (formatChecker(e.target.files[0].name)) {
      if (!e.target.files || e.target.files.length === 0) {
        setForm({ ...form, [element.key]: undefined });
      }
      if (single) {
        setForm({ ...form, [element.key]: e.target.files[0] });
      } else {
        if (form[element.key]) {
          if (typeof form[element.key] == "object") {
            setForm({
              ...form,
              [element.key]: [...form[element.key], ...e.target.files],
            });
          } else {
            setForm({
              ...form,
              [element.key]: e.target.files,
            });
          }
        } else {
          setForm({ ...form, [element.key]: e.target.files });
        }
      }
    }

  };
  const renderMulti = () => {
    // console.log("f", form);
    if (form[element.key]) {
      if (
        typeof form[element.key] == "object" &&
        !Array.isArray(form[element.key])
      ) {
        return Array.from(form[element.key])
          .filter(Boolean)
          .map((img, count) => {
            return (
              <div className="position-relative">
                <img src={URL.createObjectURL(img)} width="110" height="110" />
                <button
                  className="deleteBtnImg"
                  onClick={() => {
                    setForm({
                      ...form,
                      [element.key]: [
                        ...[...form[element.key]]
                          .filter(imgF => imgF.name != img.name)
                          .filter(Boolean),
                      ],
                    });
                  }}
                >
                  <AiOutlineClose />
                </button>
              </div>
            );
          });
      } else {
        return form[element.key].map(img => {
          return (
            <div className="position-relative">
              <img src={img.url || URL.createObjectURL(img)} width="110" height="110" />
              <button
                className="deleteBtnImg"
                onClick={() => {
                  setForm({
                    ...form,
                    [element.key]: [
                      ...[...form[element.key]]
                        .filter(imgF => imgF.name != img.name)
                        .filter(Boolean),
                    ],
                  });
                }}
              >
                <AiOutlineClose />
              </button>
            </div>
          );
        });
      }
    } else {
      return <></>;
    }
  };
  const render = () => {
    if (single) {
      return (
        <div className="d-flex align-items-center mt-3">
          <div className="add">
            <input
              id="fileUploader"
              type={"file"}
              className="d-none"
              accept="image/*"
              multiple
              onChange={onSelectFile}
            />
            <label
              className="dz-message d-block  w-100"
              htmlFor="fileUploader"
              style={{ cursor: "pointer" }}
            >
              <>
                <div className="d-flex justify-content-center">
                  <AiOutlinePlus size={"2rem"} />
                </div>
              </>
            </label>
          </div>
          <div className="me-3">
            {form[element.key] &&
              (form[element.key].url ? (
                <>
                  <img
                    className="dz-image"
                    alt="29.png"
                    data-dz-thumbnail="data-dz-thumbnail"
                    src={form[element.key].url}
                    style={{
                      borderRadius: "15px",
                      width: "110px",
                      height: "110px",
                      objectFit: "contain",
                    }}
                  />
                </>
              ) : (
                <img
                  className="dz-image"
                  alt="29.png"
                  data-dz-thumbnail="data-dz-thumbnail"
                  src={
                    form[element.key] && URL.createObjectURL(form[element.key])
                  }
                  style={{
                    borderRadius: "15px",
                    width: "110px",
                    height: "110px",
                    objectFit: "contain",
                  }}
                />
              ))}
          </div>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center mt-3">
          <div className="images">{renderMulti()}</div>
          <div className="add">
            <input
              id="multiUplpader"
              type={"file"}
              className="d-none"
              accept="image/*"
              multiple
              onChange={onSelectFile}
            />
            <label
              className="dz-message d-block  w-100"
              htmlFor="multiUplpader"
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex justify-content-center">
                <AiOutlinePlus size={"2rem"} />
              </div>
            </label>
          </div>
        </div>
      );
    }
  };
  return (
    <div className="image-uploader-wrapper  ">
      <div>
        <div>
          <label className="labelinput">{element.label}</label>
        </div>
        <smal className="fs-10">{element.subLabel}</smal>
      </div>
      {render()}
    </div>
  );
};

export default ImageUploader;

const formatChecker = (file) => {
  let parts = file.split('.').slice(-1)[0];
  switch (parts) {
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'png':
      return true;
  }

  toast.error("لطفا فقط عکس وارد کنید ", {
    position: toast.POSITION.TOP_RIGHT
  });

  return false;
}